import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

/*
  Generated class for the AuthStoreProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class AuthStoreProvider {

  constructor(public http: HttpClient) {
    console.log('Hello AuthStoreProvider Provider');
  }

}



// WEBPACK FOOTER //
// ./src/providers/auth-store/auth-store.ts